import {CommonService} from '@services/common';
import {OctDocumentService} from '@services/document';
import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class PusherJsApiService extends CommonService {
  document = inject(OctDocumentService);

  get activeCompany(): string {
    return this.document.activeCompanyPrefix();
  }

  getBroadcastSettings(): Observable<{key: string; cluster: string}> {
    return this._http.get<{
      key: string;
      cluster: string;
    }>(`${this.apiUrl}/companies/${this.activeCompany}/settings/broadcast`);
  }
}
